import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';

async function removeCustomContributorCount(): Promise<void> {
  await remove('/api/organization/custom_contributor_count');
}

/**
 * Hook to remove the custom contributor count for the current organization.
 * @param onSuccessCallback - Optional callback to execute after successful removal
 * @returns Mutation function to remove custom contributor count
 */
export const useRemoveCustomContributorCount = (onSuccessCallback?: () => void) => {
  return useToastedMutation({
    mutationFn: removeCustomContributorCount,
    successToastMessage: 'Custom contributor count removed successfully',
    errorToastMessage: 'Failed to remove custom contributor count',
    onSuccess: onSuccessCallback,
  });
};
